import React from "react";
import { useSelector } from "react-redux";
import useSystemClock from "modules/system/hooks/useSystemClock";
import { selectIsEventManager } from "modules/event/selectors";
import useBroadcastActions from "./hooks/useBroadcastActions";
import {
  selectDelay,
  selectIsBroadcasting,
  selectStartedAt,
} from "./redux/selectors";
import { BroadcastDialog } from "./components/BroadcastDialog";

const BroadcastSubscriber = () => {
  const timerRef = React.useRef<number | null>();
  const isBroadcasting = useSelector(selectIsBroadcasting);
  const startedAt = useSelector(selectStartedAt);
  const delay = useSelector(selectDelay);
  const { getCurrentTime } = useSystemClock();
  const { subscribe, unsubscribe, enterBroadcast } = useBroadcastActions();
  const hasEventManagerAccess = useSelector(selectIsEventManager);
  const delta = React.useMemo(
    () => (startedAt && delay ? startedAt + delay - getCurrentTime() : null),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [startedAt, delay],
  );

  React.useEffect(() => {
    if (isBroadcasting) {
      if (timerRef.current) {
        window.clearTimeout(timerRef.current);
      }
      timerRef.current = window.setTimeout(() => {
        enterBroadcast();
      }, delta ?? 0);
    } else if (timerRef.current) {
      window.clearTimeout(timerRef.current);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isBroadcasting, delta]);

  React.useEffect(() => {
    subscribe();

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <BroadcastDialog isEventManager={hasEventManagerAccess} />;
};

export default BroadcastSubscriber;
